import themes from "../../styles/colorScheme-config"

const formatTheme = data => {
  const themeOptions = themes() || []

  return themeOptions.find(type => {
    if (data?.theme) {
      return type?.theme === data?.theme
    } else {
      return type?.theme === "white"
    }
  })
}

export const formatThemePreset = theme => {
  switch (theme) {
    case "White":
      return "t2-preset-theme-one"
    case "Grey":
    case "Gray":
      return "t2-preset-theme-two"
    case "Black":
      return "t2-preset-theme-three"
    case "Blue":
      return "t2-preset-theme-four"
    case "Dark Blue":
      return "t2-preset-theme-five"
    case "Textured Light":
      return "t2-preset-theme-six" // transparent bg
    case "Textured Dark":
      return "t2-preset-theme-seven"
    default:
      return "t2-preset-theme-one"
  }
}
export default formatTheme
